module.exports = __webpack_public_path__ + "static/media/coktail.3b06e23e.jpg";